import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CatalogImage from '../catalog/CatalogImage';
import ProductPrice from '../catalog/ProductPrice';
import WishlistHeartButton from '../wishlist/WishlistHeartButton';
import { formatProductTitle } from '../formatProductTitle';
import { productDetailPath } from '../productPaths';
import { productGalleryImagePaths, productHasVideo, videoPosterSrc } from '../productMediaUtils';
import {
  productCharPersonalizationEnabled,
} from '../productPersonalization';
import { productJewelryCustomizationEnabled } from '../jewelry/jewelryCustomization';

/**
 * Premium horizontal-shelf product card — Shopify Dawn / Prestige feel.
 */
export default function ProductShelfCard({ product, categorySlug, className = '' }) {
  const cat = categorySlug || product?.category || '';
  const detailPath = productDetailPath({ ...product, category: cat });
  const title = formatProductTitle(product?.name || '');
  const galleryPaths = productGalleryImagePaths(product);
  const primaryImage = galleryPaths[0] || '';
  const hoverImage = galleryPaths[1] || primaryImage;
  const hasAltImage = galleryPaths.length > 1;
  const isVideo = productHasVideo(product);
  const isCustomizable =
    productCharPersonalizationEnabled(product) ||
    productJewelryCustomizationEnabled(product) ||
    product?.type === 'personalized';

  const [hovered, setHovered] = useState(false);

  return (
    <article
      className={`product-shelf-card ${className}`.trim()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="product-shelf-card__media">
        <WishlistHeartButton
          product={product}
          categorySlug={cat}
          size="sm"
          className="product-shelf-card__wishlist"
        />
        {isCustomizable ? (
          <span className="product-shelf-card__badge">Customizable</span>
        ) : null}
        <Link to={detailPath} className="product-shelf-card__link" tabIndex={-1} aria-hidden>
          {isVideo ? (
            <img
              src={videoPosterSrc(product)}
              alt={title}
              className="product-shelf-card__img product-shelf-card__img--primary"
              loading="lazy"
            />
          ) : (
            <>
              <CatalogImage
                src={primaryImage}
                alt={title}
                className={`product-shelf-card__img product-shelf-card__img--primary${hovered && hasAltImage ? ' is-hidden' : ''}`}
                loading="lazy"
                sizes="(max-width: 768px) 45vw, 260px"
              />
              {hasAltImage ? (
                <CatalogImage
                  src={hoverImage}
                  alt=""
                  className={`product-shelf-card__img product-shelf-card__img--hover${hovered ? ' is-visible' : ''}`}
                  loading="lazy"
                  sizes="(max-width: 768px) 45vw, 260px"
                />
              ) : null}
            </>
          )}
          <span className="product-shelf-card__overlay" aria-hidden>
            <span className="product-shelf-card__view">View product</span>
          </span>
        </Link>
      </div>
      <div className="product-shelf-card__body">
        <h3 className="product-shelf-card__title">
          <Link to={detailPath}>{title}</Link>
        </h3>
        <ProductPrice product={product} className="product-shelf-card__price" showBadge={false} />
      </div>
    </article>
  );
}
